import { useAuth } from "../context/AuthContext";

export const usePermissions = () => {
  const { user } = useAuth();

  // hasRole pero usando el campo `perfil`
  const hasRole = (perfil) => {
    return user?.perfil === perfil;
  };

  // Si en un futuro tu backend te devuelve permisos, aquí se integran
  const hasPermission = (permission) => {
    return user?.permissions?.includes(permission) || false;
  };

  return {
    hasRole,
    hasPermission,
    perfil: user?.perfil || null,
    userData: user || {}
  };
};
